<template>
  <fragment>
    <v-data-iterator
      :items="vocabularyListByLanguage"
      :search="search"
      :custom-filter="customFilter"
      disable-pagination
      disable-sort
      :no-results-text="$t('app.noMatchingData')"
      no-data-text=""
      hide-default-footer>
      <template v-slot:header>
        <v-text-field
          v-model="search"
          :placeholder="isFocused ? '' : $t('app.search')"
          append-icon="search"
          @blur="isFocused = false"
          @focus="isFocused = true"
          hide-details
          clearable
          autocomplete="off" />
      </template>
      <template v-slot:default="props">
        <v-row class="text-center pt-6">
          <v-col
            v-for="(vocabulary, index) in props.items" :key="`mvVocabulary-${index}`"
            class="text-right"
            cols="12">
            <MvContainer
              :vocabulary="vocabulary"
              :vocabulary-list="vocabularyList"
              :vocabulary-list-keys="vocabularyListKeys"
              @delete:mvContainer="deleteMvContainer"
              @updated:vocabulary="getVocabularyData" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
    <v-row class="text-center pt-12">
      <p v-if="vocabularyListByLanguage.length === 0">
        {{ $t('myVocabulary.noVocabulariesCreated', {languageSet: `${userLanguages.base} - ${userLanguages.learning }`}) }}
      </p>
      <v-col cols="12">
        <MvActionButton
          :vocabulary-list-by-language="vocabularyListByLanguage"
          :vocabulary-list-keys="vocabularyListKeys"
          @updated:vocabulary="getVocabularyData" />
      </v-col>
    </v-row>
  </fragment>
</template>

<script>
import { mapGetters } from 'vuex';
import MvContainer from '@components/mv_manager/mv_container';
import MvActionButton from '@components/mv_manager/action_button';
import { VOCABULARIES } from '@/config/firestore';
import removeFieldFrom from '@/mixins/firestore/removeFieldFrom';
import getMyVocabularyList from '@/mixins/vocabularies/getMyVocabularyList';
import getDataFrom from '@/mixins/firestore/getDataFrom';

export default {
  name: 'MvManager',
  components: {
    MvContainer,
    MvActionButton,
  },
  mixins: [removeFieldFrom, getDataFrom, getMyVocabularyList],
  data: () => ({
    vocabularyList: [],
    vocabularyListKeys: [],
    search: '',
    isFocused: false,
  }),
  computed: {
    ...mapGetters('user', ['userUid', 'userLanguages']),

    vocabularyListByLanguage() {
      const userLanguage = Object.values(this.userLanguages).join('-');
      return this.vocabularyList.filter((item) => item.lang === userLanguage);
    },
  },
  methods: {
    async getVocabularyListKeys() {
      this.vocabularyListKeys = Object.keys(await this.getDataFrom(VOCABULARIES) || {});
    },
    async getVocabularyList() {
      this.vocabularyList = await this.getMyVocabularyList();
    },
    async getVocabularyData() {
      await this.getVocabularyListKeys();
      await this.getVocabularyList();
    },
    async deleteMvContainer(topicIndex) {
      await this.removeFieldFrom(VOCABULARIES, topicIndex);
      await this.getVocabularyData();
    },
    customFilter(items, search) {
      if (!search || search.length === 0) {
        return items;
      }

      return items.filter((item) => {
        const searchLowCase = search.toLowerCase();
        const isInTopic = item[this.userLanguages.base].toLowerCase().indexOf(searchLowCase) !== -1;
        const isInVocabulary = item.vocabularies
          .some((vocabulary) => Object.values(vocabulary)
            .some((val) => val.toLowerCase().indexOf(searchLowCase) !== -1));

        return isInTopic || isInVocabulary;
      });
    },
  },
  async  created() {
    await this.getVocabularyData();
  },
};
</script>
